import { createAsyncThunk } from '@reduxjs/toolkit';
import { MonitorSummary } from 'features/admin-monitoring/monitorType';
import { reportApiError } from 'features/shared/reportApiError';
import api from 'libs/api';
import { AsyncThunkConfig } from 'store/types';

export type SetMonitorEnabledArgs = {
  monitorKey: string;
  enabled: boolean;
};

export const setMonitorEnabled = createAsyncThunk<
  MonitorSummary,
  SetMonitorEnabledArgs,
  AsyncThunkConfig
>(
  'monitoring/setMonitorEnabled',
  async ({ monitorKey, enabled }, { dispatch, rejectWithValue }) => {
    try {
      const response = await api.monitor.updateMonitorEnabled(
        monitorKey,
        enabled
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(reportApiError(error, dispatch));
    }
  }
);
